import React, { useMemo } from 'react'
import { NavLink } from 'react-router-dom'

export const RelatoryMenu = () => {


    const ActiveClassName = useMemo(():string => {
        return 'border-b-4 text-gray-900 border-gray-900 font-bold'
    },[])
    const ClassName = useMemo(():string => {
        return 'border-b-2 text-gray-700 border-gray-600'
    },[])
    const renderLink = useMemo(()=>{
        return "/admin/relatorios"
     },[])
    return (
        <div className={`grid grid-cols-9 mt-6`}>
        <NavLink className={ ({ isActive }) =>
          isActive ? ActiveClassName: ClassName
        } end to={`${renderLink}`}>Geral </NavLink>
        <NavLink className={({ isActive }) =>
          isActive ? ActiveClassName+' text-center': ClassName+' text-center'
        } end to={`${renderLink}/por-regiao`}>Por região</NavLink>
        <NavLink className={({ isActive }) =>
          isActive ? ActiveClassName+' text-center': ClassName+' text-center'
        } end to={`${renderLink}/por-causa`}>Por causa</NavLink>
        <div className={`${'col-span-4'} border-b-2 border-gray-600`}></div>
    </div>
    )
}
